
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"21","height":"21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M8.76 0H13a8 8 0 018 8v4.24a8 8 0 01-8 8H8.76a8 8 0 01-8-8V8a8 8 0 018-8zm6.37 9.87a.75.75 0 00.75-.75l.01-3.25a.75.75 0 00-.75-.75h-3.26a.78.78 0 100 1.56h1.39l-5.89 5.88v-1.44a.75.75 0 00-1.5 0v3.22a.72.72 0 000 .29.78.78 0 00.45.49.92.92 0 00.28 0h3.27a.75.75 0 100-1.5h-1.5l6-6v1.5c0 .414.335.75.75.75z","fill":"#7B01B5"}})])
          )
        }
      }
    